import { Component, OnInit } from '@angular/core'
import { ApiService } from '../../services/api.service'
import { ActivatedRoute } from '@angular/router'

@Component({
  selector: 'app-logout',
  templateUrl: './logout.component.html',
})
export class LogoutComponent implements OnInit {
  constructor(
    private api: ApiService,
    private route: ActivatedRoute
  ) {}

  ngOnInit(): void {
    const redirectUrl = this.route.snapshot.queryParamMap.get('redirect') || undefined
    this.api.logout(redirectUrl)
  }
}
